import React from 'react';

export default function Impostazioni() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Impostazioni</h1>
      <p>Qui potrai gestire le impostazioni del tuo account.</p>
    </div>
  );
}
